export default function (axios) {
  return {
    record(body, params) {
      return axios.post('/modules/analytics/record', body, params)
    },
  }
}
